// extracted by mini-css-extract-plugin
export default {"placeholder":"TextInput3_placeholder__Rqw7Z","textInput":"TextInput3_textInput__aBK1F"};